import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  ElementRef,
  OnInit,
  forwardRef,
  EventEmitter,
  Output,
  AfterViewInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  ToolBarToolComponent
} from '@progress/kendo-angular-toolbar';
import {
  DropDownListComponent,
  DropDownFilterSettings
} from '@progress/kendo-angular-dropdowns';
import {
  Observable
} from 'rxjs';

export function outerWidth(element: any): number {
  let width = element.offsetWidth;
  const style = getComputedStyle(element);

  width += parseFloat(style.marginLeft) || 0 + parseFloat(style.marginRight) || 0;
  return width;
}

@Component({
  providers: [{
    provide: ToolBarToolComponent,
    useExisting: forwardRef(() => ToolbarSelectComponent)
  }],
  selector: 'app-toolbar-select',
  templateUrl: './toolbar-select.component.html',
})
export class ToolbarSelectComponent extends ToolBarToolComponent implements OnInit, AfterViewInit {

  @Input() public text: string;
  @Input() data$: Observable<any>;
  filteredData: any;
  data: any;
  @Input() icon: string;
  @Input() textField: string;
  @Input() valueField: string;
  @Input() valueIndex: number;
  @Input() filterSettings: DropDownFilterSettings;
  @Input() filterable: boolean;
  @Input() defaultItem: any;
  @Output() valueChange = new EventEmitter();

  @ViewChild('toolbarTemplate', {
    static: true
  }) public toolbarTemplate: TemplateRef < any > ;
  @ViewChild('toolbarElement', {
    static: false
  }) public toolbarElement: ElementRef;

  @ViewChild('dropdownlist', {
    read: DropDownListComponent,
    static: false
  }) public dropdownlist: DropDownListComponent;
  @ViewChild('button', {
    static: false
  }) public button: ElementRef;

  public tabindex = -1;
  public itemDisabled: (itemArgs: {
    dataItem: any;
    index: number;
  }) => boolean;
  @Input() value$: Observable < any > ;
  value: any;

  constructor(private cdr: ChangeDetectorRef) {
    super();
  }

  filterChanged(value: string) {
    this.filteredData = this.data;
    if (!value) {
      return;
    }
    if (this.text === 'Client') {
     return this.filteredData = this.data.filter(item => item[this.textField].toLowerCase().startsWith(value)); 
    }
    this.filteredData = this.data.filter(item => item[this.textField].toLowerCase().includes(value));
  }

  valueChanged(value: any) {
    this.valueChange.emit(value);
  }

  public ngOnInit() {
    this.itemDisabled = (itemArgs: {
        dataItem: any;
        index: number;
      }) => !this.overflows && this.dropdownlist && !this.dropdownlist.isOpen;
    if (this.data$) {
        this.data$.subscribe(data => {
        this.filteredData = data;
        this.data = data;
      });
    }
  }

  public ngAfterViewInit() {
    if (this.value$) {
      this.value$.subscribe(value => {
        this.value = value;
      });
    }
  }

  public get outerWidth(): number {
    if (this.toolbarElement) {
      return outerWidth(this.toolbarElement.nativeElement);
    }
  }

  public canFocus(): boolean {
    return true; // marks the tools as focusable
  }

  public focus(): void {
    // manage the roving tabindex
    // see https://www.w3.org/TR/wai-aria-practices/#kbd_roving_tabindex
    this.tabindex = 0;
    if (this.overflows) {
      // focus the button in the overflowTemplate
      this.button.nativeElement.focus();
    }
  }

  public handleKey(): boolean {
    // manage the roving tabindex
    // see https://www.w3.org/TR/wai-aria-practices/#kbd_roving_tabindex
    this.tabindex = -1;
    // tell the toolbar that the focus can move to the next/prev focusable tool
    return false;
  }
}
